import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function WhyTrustUs() {
  return <section className="py-16 md:py-24 px-4 bg-surface-gray" data-id="element-383">
      <div className="max-w-4xl mx-auto" data-id="element-384">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-385">
          <div className="w-16 h-16 bg-brand-green/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-386">
            <ShieldCheck className="w-8 h-8 text-brand-green" data-id="element-387" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-slate-dark mb-6" data-id="element-388">
            ¿Por qué creamos este material?
          </h2>
          <div className="text-lg text-slate space-y-4 max-w-2xl mx-auto font-medium" data-id="element-389">
            <p data-id="element-390">
              Miles de personas buscan respuestas todos los días y encuentran
              información confusa, incompleta o contradictoria.
            </p>
            <p data-id="element-391">
              Por eso reunimos todo en un solo lugar, explicado en lenguaje
              simple y adaptado a la realidad uruguaya.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col md:flex-row items-center gap-8 max-w-3xl mx-auto" data-id="element-392">
          <div className="w-32 h-32 bg-surface-gray rounded-full flex-shrink-0 border-4 border-white shadow-md overflow-hidden flex items-center justify-center" data-id="element-393">
            {/* Photo Placeholder */}
            <span className="text-brand-green/30 font-black text-4xl" data-id="element-394">AP</span>
          </div>
          <div className="text-center md:text-left" data-id="element-395">
            <h3 className="text-xl font-black text-slate-dark mb-2" data-id="element-396">
              Equipo AvanzaPro
            </h3>
            <p className="text-slate italic" data-id="element-397">
              "Comprometidos con crear contenido educativo de calidad para
              ayudar a las personas a comprender mejor el sistema financiero."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}